import { SgvJson } from '@eceos/arch';

export class SupportBankSlipEvent {
  constructor(
    public type = '',
    public instant: Date = null
  ) {}

  get typeLabel(): string {
    const labels: Record<string, string> = {
      'BankSlipImportedConfirmedEntryEvent': 'Entrada Confirmada (Importado)',
      'PjBankConfirmedEntryEvent': 'Entrada Confirmada (PjBank)',
      'PjBankCanceledEntryEvent': 'Cancelado (PjBank)',
      'BankSlipManualReversedEvent': 'Estornado Manualmente',
      'BankSlipManualPaymentEvent': 'Pagamento Manual',
      'BankSlipManualFinalizedEvent': 'Finalizado Manualmente',
      'BankSlipImportedPaymentEvent': 'Pagamento (Importado)',
      'PjBankPaymentEvent': 'Pagamento (PjBank)',
      'BankSlipShippingFileEvent': 'Arquivo Remessa Gerado',
      'BankSlipFinalizedByImportedPaidEvent': 'Finalizado por Pagamento',
      'BankSlipRejectedEntryEvent': 'Entrada Rejeitada',
    };
    return labels[this.type] || this.type;
  }

  static fromJson(json: any): SupportBankSlipEvent {
    return SgvJson.from.simple(json, SupportBankSlipEvent, {
      instant: json.instant ? new Date(json.instant) : null
    });
  }
}
